import { TherapistAction } from '../../actions/constant';

const {
  GET_PAYCOME_PROVIDER_REQUEST,
  GET_PAYCOME_PROVIDER_SUCCESS,
  GET_PAYCOME_PROVIDER_FAILURE,
  GET_PAYCOME_PROVIDER_LOADER,
  GET_PAYCOME_PROVIDER_RESET,
} = TherapistAction;

const intitialstate: object = {
  getPayComeDetails: false,
  response: null,
  loader: false,
};

export const thePayComeDetailsReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_PAYCOME_PROVIDER_SUCCESS: {
      return {
        ...state,
        getAdminProfile: true,
        response: action.payload,
        loader: false,
      };
    }

    case GET_PAYCOME_PROVIDER_FAILURE:
      return {
        ...state,
        getAdminProfile: false,
        response: action.payload,
        loader: false,
      };

    case GET_PAYCOME_PROVIDER_REQUEST:
      return {
        ...state,
        loader: true,
      };

    case GET_PAYCOME_PROVIDER_RESET:
      return intitialstate;

    default:
      return state;
  }
};
